export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const IMAGE_API_BASE_URL =
  process.env.REACT_APP_IMAGE_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL;
export const API_ENDPOINTS = {
  BASE: API_BASE_URL,

  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    // REGISTER: `${API_BASE_URL}/auth/register`,
    SIGNUP: `${API_BASE_URL}/auth/signup`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    PROFILE: `${API_BASE_URL}/auth/profile`,
    REFRESH: `${API_BASE_URL}/auth/refresh`,
    CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
    SEND_EMAIL_OTP: `${API_BASE_URL}/otp/send-email-otp`,
    VERIFY_EMAIL_OTP: `${API_BASE_URL}/otp/verify-email-otp`,

    SEND_PHONE_OTP: `${API_BASE_URL}/otp/send-phone-otp`,
    VERIFY_PHONE_OTP: `${API_BASE_URL}/otp/verify-phone-otp`,

    FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
  },
  USERS: {
    GET_PROFILE: (id: string | number): string =>
      `${API_BASE_URL}/users/profile/${id}`,
    UPDATE_PROFILE: (id: string | number): string =>
      `${API_BASE_URL}/users/profile/${id}`,
    UPDATE_FACIAL_VERIFICATION: (id: string | number): string =>
      `${API_BASE_URL}/users/profile/${id}/facial-verification`,
    UPDATE_BANK_DETAILS: (id: string | number): string =>
      `${API_BASE_URL}/users/bank-details/${id}`,
  },
  CLIENTS: {
    GET_ALL: `${API_BASE_URL}/clients`,
    GET_BY_ID: (id: string | number): string => `${API_BASE_URL}/clients/${id}`,
    CREATE: `${API_BASE_URL}/clients`,
    UPDATE: (id: string | number): string => `${API_BASE_URL}/clients/${id}`,
    DELETE: (id: string | number): string => `${API_BASE_URL}/clients/${id}`,
  },
  TRADES: {
    GET_ALL: `${API_BASE_URL}/trades`,
    GET_BY_ID: (id: string | number): string => `${API_BASE_URL}/trades/${id}`,
    CREATE: `${API_BASE_URL}/trades`,
    UPDATE: (id: string | number): string => `${API_BASE_URL}/trades/${id}`,
    DELETE: (id: string | number): string => `${API_BASE_URL}/trades/${id}`,
  },
  ADMIN: {
    DASHBOARD: `${API_BASE_URL}/admin/dashboard`,
    USERS: `${API_BASE_URL}/admin/users`,
    CREATE_CLIENT: `${API_BASE_URL}/admin/signup`,
    GET_USER_BY_ID: (id: string | number): string =>
      `${API_BASE_URL}/admin/users/${id}`,
    UPDATE_USER: (id: string | number): string =>
      `${API_BASE_URL}/admin/users/${id}`,
    DELETE_USER: (id: string | number): string =>
      `${API_BASE_URL}/admin/users/${id}`,
    UPDATE_USER_STATUS: (id: string | number): string =>
      `${API_BASE_URL}/admin/users/${id}/status`,
  },
  ACCOUNT: {
    CREATE: `${API_BASE_URL}/account/create`,
    VALIDATE_REFERRAL: `${API_BASE_URL}/account/validate-referral`,
    EXPORT_DATA: `${API_BASE_URL}/account/export-data`,
  },
  DOCUMENT_VERIFY: {
    OCR_VERIFY: `${API_BASE_URL}/kyc/extract-document`,
  },
  VERIFY: {
    AADHAAR: `${API_BASE_URL}/verify/aadhaar`,
    PAN: `${API_BASE_URL}/verify/pan`,
    PASSPORT: `${API_BASE_URL}/verify/passport`,
  },
  KYC: {
    STORE_AADHAAR_VERIFICATION: `${API_BASE_URL}/aadhaar-verify`,
    STORE_PAN_VERIFICATION: `${API_BASE_URL}/pan-verify`,
    STORE_PASSPORT_VERIFICATION: `${API_BASE_URL}/passport-verify`,
    STORE_FACIAL_VERIFICATION: `${API_BASE_URL}/face-verify`,
  },
  BANK: {
    ADD_BANK_DETAILS: `${API_BASE_URL}/user-bank-details/add`,
  },
  CHATBOT: {
    SEND_MESSAGE: `${API_BASE_URL}/chatbot/message`,
  },
  SUPPORT_TICKETS: {
    CREATE: `${API_BASE_URL}/support-tickets`,
    GET_ALL: `${API_BASE_URL}/admin/support-tickets`,
    GET_USER_TICKETS: `${API_BASE_URL}/support-tickets/my-tickets`,
    GET_BY_ID: (id: string): string => `${API_BASE_URL}/support-tickets/${id}`,
    UPDATE: (id: number): string =>
      `${API_BASE_URL}/admin/support-tickets/${id}`,
    USER_UPDATE_TICKET: (ticketId: string): string =>
      `${API_BASE_URL}/support-tickets/${ticketId}`,
    DELETE: (id: string): string => `${API_BASE_URL}/support-tickets/${id}`,
    ADMIN_DELETE: (id: string): string =>
      `${API_BASE_URL}/admin/support-tickets/${id}`,
  },
  ECONOMIC_CALENDAR: {
    GET_ALL: `${API_BASE_URL}/calendar`,
    GET_BY_ID: (id: string): string => `${API_BASE_URL}/calendar/${id}`,
    CREATE: `${API_BASE_URL}/calendar`,
    UPDATE: (id: string): string => `${API_BASE_URL}/calendar/${id}`,
    DELETE: (id: string): string => `${API_BASE_URL}/calendar/${id}`,
    GET_ALL_COUNTRIES: `${API_BASE_URL}/countries`,
  },
  MT5: {
    CREATE_ACCOUNT: `${API_BASE_URL}/mt5/user/create`,
    GET_USERS: `${API_BASE_URL}/mt5/users`,
    GET_USER: (login: string | number): string =>
      `${API_BASE_URL}/mt5/user/${login}`,
    GET_GROUPS: `${API_BASE_URL}/mt5/groups`,
    CREATE_DEPOSITE: `${API_BASE_URL}/mt5/deposit`,
    CREATE_WITHDRAW: `${API_BASE_URL}/mt5/withdraw`,
    WALLET_TRANSACTIONS: `${API_BASE_URL}/mt5/wallet`,
    Wallet_Transection: (login: string | number): string =>
      `${API_BASE_URL}/mt5/wallet/${login}`,
    LEVERAGE_HISTORY: `${API_BASE_URL}/mt5/leverage/history`,
    LEVERAGE_HISTORY_BY_LOGIN: (login: string | number): string =>
      `${API_BASE_URL}/mt5/leverage/history/${login}`,
    CHANGE_LEVERAGE: `${API_BASE_URL}/mt5/leverage`,
    TRANSACTIONS: (type?: string, status?: string): string =>
      `${API_BASE_URL}/mt5/transactions${type ? `?type=${type}` : ''}${status ? `${type ? '&' : '?'}status=${status}` : ''}`,
    ACCOUNT: {
      GET_LIST: (group?: string): string =>
        `${API_BASE_URL}/mt5/account/list${group ? `?group=${group}` : ''}`,
      GET_SINGLE: (login: string | number): string =>
        `${API_BASE_URL}/mt5/account/${login}`,
    },
    GET_TRADES: `${API_BASE_URL}/mt5/trades`,
    GET_TRADES_BYID: (login: string | number): string =>
      `${API_BASE_URL}/mt5/trades/${login}`,
    CREATE_TRANSFER: `${API_BASE_URL}/mt5/transfer`,
  },
  HEALTH: `${API_BASE_URL}/mt5/health`,
} as const;

export default API_ENDPOINTS;
